import { isFeatureEnabledForEnvironment } from '@logto/schemas';
import { yes } from '@silverhand/essentials';

export const isCloud = yes(process.env.IS_CLOUD);
export const isDevFeaturesEnabled =
  process.env.NODE_ENV !== 'production' || yes(process.env.DEV_FEATURES_ENABLED);

export const isStepUpAuthenticationEnabled = isFeatureEnabledForEnvironment(
  'stepUpAuthentication',
  { isCloud, isDevFeaturesEnabled }
);
